import { initialState } from '../intialState';
import { BUNDLE_ACTIONS } from '../actions';
import { cloneDeep } from 'lodash';
import { ActionReducer, combineReducers, MetaReducer } from '@ngrx/store';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';
/*export function formDataBindingReducer(state = initialState.dataBindings, action): Array<any> {
  switch (action.type) {
    case BUNDLE_ACTIONS.ADD_DATABINDINGS:
      const newState = cloneDeep(state);
      const data = action.payload;
      if (!(data.name in newState)) {
        newState[data.name] = data.dataBindings;
      }
      return newState;
      case BUNDLE_ACTIONS.REMOVE_DATABINDINGS:
        const updatedState = cloneDeep(state);
        const identifier = get('name', action.payload);
        if (identifier in updatedState) {
         delete updatedState[identifier];
        }
        return updatedState;
    default:
      return state;
  }
}
export function itemConfigBindingReducer(state = initialState.configBindings, action): Array<any> {
  switch (action.type) {
    case BUNDLE_ACTIONS.ADD_CONFIG_BINDINGS:
      const newState = cloneDeep(state);
      const data = action.payload;
      if (!(data.name in newState)) {
        newState[data.name] = data.configBindings;
      }
      return newState;
      case BUNDLE_ACTIONS.REMOVE_CONFIG_BINDINGS:
        const updatedState = cloneDeep(state);
        const identifier = get('name', action.payload);
        if (identifier in updatedState) {
         delete updatedState[identifier];
        }
        return updatedState;
    default:
      return state;
  }
}*/
export function queryDataReducer(state = initialState, action): Array<any> {
  let newState: any = []; let cardData: any;
  let tempstate: any = [];
  switch (action.type) {
    case BUNDLE_ACTIONS.UPDATE_QUERIES_DATA:
      tempstate = cloneDeep(state);
      return tempstate.concat(action.payload);

    case BUNDLE_ACTIONS.ONE_FORM_UPDATE:
      newState = [];
      tempstate = cloneDeep(state);
      cardData = action.payload;
      tempstate.forEach((element, index) => {
        cardData.forEach(item => {
          if (index === item['index']) {
            /* new Proxy(item, {
                 set(target, property,value){
                     if(property === 'hb_showall'){
                         debugger;
                     }
                     return Reflect.set(...arguments);
                 }
                 });
             _.set(item, 'hb_showall', )*/
            delete item['index'];
            element = item.data;
          }
        });
        newState.push(element);
      });
      return newState;

    case BUNDLE_ACTIONS.UPDATE_INDEX_QUERIES_DATA:
      newState = [];
      tempstate = cloneDeep(state);
      cardData = action.payload;
      tempstate.forEach((element, index) => {
        cardData.forEach(item => {
          if (index === item['index']) {
            delete item['index'];
            element = item;
          }
        });
        newState.push(element);
      });
      return newState;
    case BUNDLE_ACTIONS.CLEAR_QUERIES_DATA:
      return [];
    default:
      return state;
  }
}

/*const reducers = {
  queriesData: queryDataReducer
};*/

// const aggregatorCombinedReducers = combineReducers(reducers, initialState);

export function aggregatorReducer(state = initialState, action) {
  return queryDataReducer(state, action);
}
export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateReducer];
